import { render } from "./RuiAddPerson.vue?vue&type=template&id=77f38daa"
const script = {}
script.render = render

export default script